import ipaddr from 'ipaddr.js';
import validator from 'validator';
import isIP from 'validator/lib/isIP';
import { parseIP } from 'netaddr';

export const appNameValidate = (value) => {
  if (value === "" || value === undefined || value === null) {
    return "App name is required.";
  } else if (value.length > 50) {
    return "Maximum 50 characters allowed in App name.";
  } else {
    return true;
  }
};

export const redircetUrlValidate = (value) => {
  if (value === "" || value === undefined || value === null) {
    return "Redirect url is required.";
  } else if (value.indexOf("http://") && value.indexOf("https://")) {
    return "Please enter a valid Redirect URL.";
  } else {
    return true;
  }
};

export const validateAppIcon = (value) => {
  const fileSize = value.size / 1024 / 1024;
  let allowedExtension = ["jpeg", "jpg", "png", "svg", "svg+xml"];
  let type = value.type.split("/")[1];

  if (allowedExtension.includes(type) === false) {
    return "Only PNG, JPEG, JPG, SVG image are allowed.";
  } else if (fileSize > 5) {
    return "Image size should be less than 5 MB";
  } else {
    return true;
  }
};
export const staticIpPrimaryValidate = (value) => {
  if (value === "" || value === undefined || value === null) {
    return "Static Ip is required.";
  } else if (!isValidIPv4(value)) {
    return "Invalid IP address format. Please input a valid IP4 address";
  } else {
    return true;
  }
};

export const staticIpSecondaryValidate = (value, primaryValue) => {
   if (!value) {
    return true;
  }
   if (!isValidIPv4(value)) {
    return "Invalid IP address format. Please input a valid IP4 address.";
  } else if (primaryValue && value === primaryValue) {
    return "Secondary IP must be different from Primary IP.";
  } else {
    return true;
  }
};
// function isValidIPv4(ip) {
//     return ipaddr.isValid(ip) && ipaddr.parse(ip).kind() === 'ipv4';
// }
function isValidIPv4(ip) {
  //   try {
  //   const parsed = parseIP(ip);
  //   return (
  //     parsed &&
  //     parsed.kind === 'ipv4' &&
  //     // !parsed.isPrivate() &&
  //     !parsed.isLoopback() &&
  //     !parsed.isMulticast() &&
  //     !parsed.isLinkLocal()
  //     // !parsed.isReserved()
  //   );
  // } catch {
  //   return false;
  // }
  try {
    if (!ipaddr.isValid(ip)) return false;

    const parsed = ipaddr.parse(ip);
    if (parsed.kind() !== 'ipv4') return false;
    
    // Reject loopback, link-local, multicast, and "this network" addresses
    if (
      parsed.range() === 'loopback' ||     // 127.0.0.0/8
      parsed.range() === 'linkLocal' ||    // 169.254.0.0/16
      parsed.range() === 'multicast' ||    // 224.0.0.0/4
      parsed.range() === 'unspecified'     // 0.0.0.0
    ) {
      return false;
    }
    
    return true;
  } catch {
    return false;
  }
}
